/**
 * Configuration object for cookie keys used in the application.
 * @property {string} AUTH_TOKEN - Key for storing the authentication token.
 * @property {string} USER_DATA - Key for storing user data.
 * @property {string} IS_AUTHENTICATED - Key indicating if the user is authenticated.
 * @property {string} REFRESH_TOKEN - Key for storing the refresh token.
 */
export const COOKIE_CONFIG = {
  AUTH_TOKEN: 'auth-token',
  USER_DATA: 'user-data',
  IS_AUTHENTICATED: 'is-authenticated',
  REFRESH_TOKEN: 'refresh-token',
  CONSENT: 'cookie-consent',
};

/**
 * Configuration options for cookies used in the application.
 *
 * @property {boolean} secure - Indicates if the cookie should only be transmitted over secure protocols (HTTPS).
 * @property {string} sameSite - Controls whether the cookie is sent with cross-site requests. Set to 'strict' for maximum security.
 * @property {number} maxAge - The maximum age of the cookie in seconds (7 days).
 */
export const COOKIE_OPTIONS = {
  DEFAULT: {
    secure: window.location.protocol === 'https:',
    sameSite: 'strict',
    maxAge: 7 * 24 * 60 * 60, // 7 days
  },
  AUTH_TOKEN: {
    secure: window.location.protocol === 'https:',
    sameSite: 'strict',
    maxAge: 24 * 60 * 60, // 1 day
  },
  REFRESH_TOKEN: {
    secure: window.location.protocol === 'https:',
    sameSite: 'strict',
    maxAge: 7 * 24 * 60 * 60, // 7 days
  },
};

/**
 * Configuration options for a short-lived cookie.
 * Extends the base COOKIE_OPTIONS and sets the maxAge to 1 day (in seconds).
 * Typically used for authentication tokens.
 *
 * @constant
 * @type {Object}
 * @property {number} maxAge - The maximum age of the cookie in seconds (1 day).
 */
export const SHORT_COOKIE_OPTIONS = {
  ...COOKIE_OPTIONS.DEFAULT,
  maxAge: 24 * 60 * 60, // 1 day for auth token
};

/** Cookie consent constants
 */
export const CONSENT_COOKIE_EXPIRY = 365; // days
